import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SignUpPage from "./pages/SignUpPage";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Historique from "./pages/Historique"
import SeminairesPage from "./pages/SeminairePage";
import RestaurantsAndMenusPage from "./pages/RestaurantsAndMenusPage";
import BoissonsPage from "./pages/BoissonsPage";
import SpasPage from "./pages/SpasPage";
import LoisirsPage from "./pages/LoisirsPage";
import OffresPage from "./pages/OffresPage";
import EvenementsPage from "./pages/EvenementsPage";
import RoomServicePage from "./pages/RoomServicePage";
import SkyLoungePage from "./pages/SkyLoungePage";
import Statistiques from "./pages/Statistiques";
import PageContents from "./pages/page-contents"

// Client pages

import Home from "./pages/Home";

import SeminairesClient from "./pages/SeminaireClient";
import RestaurantsMenusClient from "./pages/RestaurantsMenusClient";
import RestaurantsMenusClientQr from "./pages/RestaurantsMenusClientQr";
import BoissonsClient from "./pages/BoissonsClient";
import BoissonsClientQr from "./pages/BoissonsClientQr";
import SpasClient from "./pages/SpasClient";
import LoisirsClient from "./pages/LoisirsClient";
import OffresClient from "./pages/OffresClient";
import EvenementsClient from "./pages/EvenementsClient";
import RoomServiceClient from "./pages/RoomServiceClient";
import SkyLoungeClient from "./pages/SkyLoungeClient";
import SettingsPage from "./pages/SettingsPage";
import ProfilePage from "./pages/ProfilePage";
import ReservationsPage from "./pages/ReservationsPage";
import NettoyagePage from "./pages/NettoyagePage";
import RoomServiceOrders from "./pages/RoomServiceOrders";
import PrivacyClient from "./pages/PrivacyClient"
import LivretClient from "./pages/LivretClient";
import IbisMusicClient from "./pages/IbisMusicClient";
import AdditionalServiceClient from "./pages/AdditionalServiceClient";
import PlanSfaxClient from "./pages/PlanSfaxClient";
import EncasClient from "./pages/EncasClient";
import SeminaireIbisClient from "./pages/SeminaireIbisClient";
import EcogesteClient from "./pages/EcogesteClient";
import PetitDejeunerClient from "./pages/PetitDejeunerClient";
import SkipCleanClient from "./pages/SkipcleanClient";
import QuestionnaireClient from "./pages/QuestionnaireClient";
import QuestionnairesPage from "./pages/QuestionnairePage"; 
import SkipCleansPage from "./pages/SkipcleanPage";
import RestaurantBarClient from "./pages/RestaurantBarClient";
import PresseClient from "./pages/PresseClient";

function App() {
  return (
    <BrowserRouter basename="">
      <Routes>
        {/* 🔐 Admin / Authenticated Routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/reservations" element={<ReservationsPage />} />
        <Route path="/nettoyage" element={<NettoyagePage />} />
        <Route path="/roomserviceorders" element={<RoomServiceOrders />} />
        <Route path="/historique" element={<Historique />} />
        <Route path="/statistiques" element={<Statistiques />} />
        <Route path="/livret-client" element={<LivretClient />} />
        <Route path="/ibis-music-client" element={<IbisMusicClient />} />
        <Route path="/page-contents" element={<PageContents />} />
        <Route path="/seminaires" element={<SeminairesPage />} />
        <Route path="/restaurants" element={<RestaurantsAndMenusPage />} />
        <Route path="/boissons" element={<BoissonsPage />} />
        <Route path="/loisirs" element={<LoisirsPage />} />
        <Route path="/spas" element={<SpasPage />} />
        <Route path="/evenements" element={<EvenementsPage />} />
        <Route path="/offres" element={<OffresPage />} />
        <Route path="/roomservices" element={<RoomServicePage />} />
        <Route path="/skylounge" element={<SkyLoungePage />} />
        <Route path="/additional-services-client" element={<AdditionalServiceClient />} />
        <Route path="/plan-sfax-client" element={<PlanSfaxClient />} />
        <Route path="/encas-client" element={<EncasClient />} />
        <Route path="/seminaire-ibis-client" element={<SeminaireIbisClient />} />
        <Route path="/ecogeste-client" element={<EcogesteClient />} />
        <Route path="/petitdejeuner-client" element={<PetitDejeunerClient />} />
        {/* 🌍 Public / Client Routes */}
        <Route path="/home" element={<Home />} />
        <Route path="/questionnaire-client" element={<QuestionnaireClient />} />
        <Route path="/skipclean-client" element={<SkipCleanClient />} />
        <Route path="/questionnaires" element={<QuestionnairesPage />} />
        <Route path="/skipcleans" element={<SkipCleansPage />} />
        <Route path="/seminaires-client" element={<SeminairesClient />} />
        <Route path="/RestaurantsMenus-client" element={<RestaurantsMenusClient />} />
        <Route path="/boissons-client" element={<BoissonsClient />} />
        <Route path="/restaurantqr" element={<RestaurantsMenusClientQr />} />
        <Route path="/barqr" element={<BoissonsClientQr />} />
        <Route path="/spas-client" element={<SpasClient />} />
        <Route path="/loisirs-client" element={<LoisirsClient />} />
        <Route path="/evenements-client" element={<EvenementsClient />} />
        <Route path="/offres-client" element={<OffresClient />} />
        <Route path="/roomservices-client" element={<RoomServiceClient />} />
        <Route path="/skylounge-client" element={<SkyLoungeClient />} />
        <Route path="/policy-client" element={<PrivacyClient />} />
        <Route path="/RestaurantBarClient" element={<RestaurantBarClient />} />
        <Route path="/PresseClient" element={<PresseClient />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
